'use client'
import * as React from 'react'
import { CheckCircleInvertedIcon } from 'primitives/icons'
import type { SearchProduct } from 'cf-menu/components/search/search.types'
import { ProductType } from 'cf-menu/components/search/search.types'
import { Link } from '@repo/web-ui/components/link'
import { decodeHtmlEntities } from 'utils/decode-html-entities'
import { slugifyCategory } from 'utils/string'

import { ClubhouseImageCard } from '../../_components/clubhouse-image-card'
import { mapCategoryPageTypeToCategoryDetails } from '@web/components/content-api/config'

export function ProductCard({ item }: { item: SearchProduct }) {
  const category = item.type ? item.type : ''
  const subcategory = item.category ? item.category[0] : ''
  const isGraphics = category === ProductType.GRAPHICS
  const isPNG = category === mapCategoryPageTypeToCategoryDetails.png.authorId

  const categoryHref = isGraphics
    ? `/subscriptions/graphics/${slugifyCategory(subcategory)}/`
    : `/${isPNG ? 'png' : slugifyCategory(category)}/`

  return (
    <ClubhouseImageCard key={item.objectID} image={item.image} href={item.url}>
      <div className="relative w-full">
        <Link
          href={item.url}
          target="_blank"
          className="text-14 line-clamp-3 text-ellipsis pr-4 font-semibold leading-5"
        >
          {decodeHtmlEntities(item.name_en)}
        </Link>
        <div className="mb-1 mt-1 flex flex-row items-center justify-start gap-1 leading-5">
          <p className="text-12 text-[#2C5ED2]">
            <span className="text-cf-black">{'In '}</span>
            <Link href={categoryHref} target="_blank">
              {item.type}
            </Link>
          </p>
        </div>
        <CheckCircleInvertedIcon className="text-cf-cricut-green absolute right-0 top-0 size-5" />
      </div>
    </ClubhouseImageCard>
  )
}
